import {
  AlertType,
  InlineAlert,
  InlineAlertTitle,
  InlineAlertSubtitle,
  InlineAlertActionsContainer,
} from 'teacher-ui-client/components/inline-alert'
import { t } from 'ember-intl'
import { LinkTo } from '@ember/routing'
import { and } from 'ember-truth-helpers'
import Component from '@glimmer/component'
import { service } from '@ember/service'
import type FeaturesService from 'teacher-ui-client/services/features'
import config from 'teacher-ui-client/config/environment'
import { join } from 'teacher-ui-client/utils/uri'

const rosterSchoolSettingsUrl = join(config.oneRosterUrl, 'login').toString().concat('?return_to=/school-settings')

interface Signature {
  Args: {
    hasDisco?: boolean
    isSubco?: boolean
    isOneRosterEnabled?: boolean
  }
}

export class NoStandardsSetAlert extends Component<Signature> {
  @service features!: FeaturesService

  get shouldUseRosterSchoolSettingsLink() {
    return this.args.isSubco && this.args.isOneRosterEnabled && this.features.isEnabled('tui_roster_standards_setting')
  }

  <template>
    <InlineAlert data-test-report-no-standards-alert @type={{AlertType.Warning}}>
      {{#if (and @isSubco @hasDisco)}}
        <InlineAlertTitle data-test-alert-heading>
          {{t "reporting.alerts.noSetStandardsAlert.districtSchool.title"}}
        </InlineAlertTitle>
        <InlineAlertSubtitle>
          <div class="text-neutral-300">{{t
              "reporting.alerts.noSetStandardsAlert.districtSchool.mustChoose"
              htmlSafe=true
            }}
          </div>
          <div class="text-neutral-300">{{t
              "reporting.alerts.noSetStandardsAlert.districtSchool.leadTime"
              htmlSafe=true
            }}
          </div>
        </InlineAlertSubtitle>
      {{else if @isSubco}}
        <InlineAlertTitle data-test-alert-heading>
          {{t "reporting.alerts.noSetStandardsAlert.standaloneSchool.title"}}
        </InlineAlertTitle>
        <InlineAlertSubtitle>
          <div class="text-neutral-300">{{t "reporting.alerts.noSetStandardsAlert.standaloneSchool.mustChoose"}}
          </div>
          <div class="text-neutral-300">{{t
              "reporting.alerts.noSetStandardsAlert.standaloneSchool.leadTime"
              htmlSafe=true
            }}
          </div>
        </InlineAlertSubtitle>
        <InlineAlertActionsContainer>
          {{#if this.shouldUseRosterSchoolSettingsLink}}
            <a
              data-test-select-standards-link
              href={{rosterSchoolSettingsUrl}}
              target="_blank"
              rel="noopener noreferrer"
              class="text-blue-325 hover:text-blue-350"
            >
              {{t "reporting.alerts.noSetStandardsAlert.standaloneSchool.selectStandardsLink"}}
            </a>
          {{else}}
            <LinkTo
              data-test-select-standards-link
              @route="subscription-type.account"
              class="text-blue-325 hover:text-blue-350"
            >
              {{t "reporting.alerts.noSetStandardsAlert.standaloneSchool.selectStandardsLink"}}
            </LinkTo>
          {{/if}}

        </InlineAlertActionsContainer>
      {{else}}
        <InlineAlertTitle data-test-alert-heading>
          {{t "reporting.alerts.noSetStandardsAlert.nonSubco.title"}}
        </InlineAlertTitle>
        <InlineAlertSubtitle>
          <div class="text-neutral-300">{{t "reporting.alerts.noSetStandardsAlert.nonSubco.mustChoose" htmlSafe=true}}
          </div>
          <div class="text-neutral-300">{{t "reporting.alerts.noSetStandardsAlert.nonSubco.leadTime" htmlSafe=true}}
          </div>
        </InlineAlertSubtitle>
      {{/if}}
    </InlineAlert>
  </template>
}

export default NoStandardsSetAlert
